import { FormHelperText, Stack, Box, Typography } from '@mui/material';
import { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';

import LoadingButton from '@/@mantis/components/@extended/LoadingButton';
import { ApiRequest_UpdatePhone_User, useUpdatePhone } from '@/api/endpoints/user/useUpdatePhone';
import { useAuth } from '@/context/AuthProvider';

import FormTextField from '@/components/form/FormTextField';

const PhoneForm: React.FC = () => {
  const { user } = useAuth();

  const {
    control,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<ApiRequest_UpdatePhone_User>({
    defaultValues: {
      phone: user?.phone ?? '',
    },
  });

  const [formError, setFormError] = useState<Error | null>(null);

  const updatePhoneMutation = useUpdatePhone({
    onError: error => {
      setFormError(error);
    },
  });

  const onSubmit = useCallback(
    (data: ApiRequest_UpdatePhone_User) => {
      setFormError(null);
      return updatePhoneMutation.mutateAsync(data);
    },
    [updatePhoneMutation]
  );

  return (
    <Stack spacing={1} component="form" onSubmit={handleSubmit(onSubmit)}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ mb: 0.5 }}
          >
            Your Phone Number
          </Typography>
          <FormTextField
            placeholder="Enter your phone number"
            size="small"
            error={!!errors.phone}
            helperText={errors.phone?.message?.toString()}
            control={control}
            required
            sx={{
              width: 200,
              '& .MuiInputBase-root': {
                height: 40,
              },
              '& .MuiInputBase-input': {
                height: '40px',
                padding: '0 8px',
                display: 'flex',
                alignItems: 'center',
                boxSizing: 'border-box',
              },
            }}
            {...register('phone', {
              required: 'Phone Number is required',
            })}
          />
        </Box>

        <LoadingButton
          loading={isSubmitting}
          variant="contained"
          type="submit"
          size="small"
          sx={{ height: 40 }}
        >
          Update Phone Number
        </LoadingButton>
      </Box>

      {!!formError && <FormHelperText error>{formError.message}</FormHelperText>}
    </Stack>
  );
};

export default PhoneForm;
